import React from 'react';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import { Text } from '../index';

export default function SelectBorderless({
  options, onChange, value, defaultValue, placeholder, minWidth, disabled, hasErrors, children, onSelect,
}) {
  const className = ['borderless'];
  if (hasErrors) className.push('danger');
  const translationIdPlaceholder = (hasErrors) ? 'generico.obligatorio' : 'generico.seleccionar';
  return (
    <Select
      dropdownStyle={{ minWidth: '160px' }}
      disabled={disabled}
      onChange={v => onChange(v)}
      onSelect={v => onSelect(v)}
      value={value !== null ? value : undefined}
      defaultValue={defaultValue}
      size="small"
      className={className}
      dropdownClassName={className}
      style={{ minWidth: (value === null || minWidth) ? minWidth : 'inherit', borderStyle: 'none' }}
      placeholder={placeholder || <Text fontSize="12" translationId={translationIdPlaceholder} />}
    >
      { children || options }
    </Select>
  );
}

SelectBorderless.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  options: PropTypes.any.isRequired,
  children: PropTypes.any,
  placeholder: PropTypes.any,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  minWidth: PropTypes.any,
  hasErrors: PropTypes.bool,
};

SelectBorderless.defaultProps = {
  onChange: () => {},
  onSelect: () => {},
  children: null,
  disabled: false,
  value: null,
  defaultValue: null,
  minWidth: '84px',
  hasErrors: false,
};
